var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.onScroll,
          expression: "onScroll",
        },
      ],
    },
    [
      _c("mini-header", {
        attrs: {
          title: "Clientes",
          dense: true,
          breadcrumbs: _vm.breadcrumbs,
          hiddenTab: true,
          scroll: _vm.scroll,
        },
        scopedSlots: _vm._u([
          {
            key: "main",
            fn: function () {
              return [
                _vm.$helpers.hasSomePermission(["view_customer"])
                  ? [
                      _c(
                        "v-btn",
                        {
                          attrs: { outlined: "", disabled: !_vm.list.length },
                          on: {
                            click: function ($event) {
                              ;(_vm.isLoadMore = true),
                                (_vm.reset += 1),
                                _vm.getList()
                            },
                          },
                        },
                        [
                          _c("v-img", {
                            attrs: {
                              contain: "",
                              src: require(`@/assets/icon-update${
                                _vm.$vuetify.theme.dark ? "-dark" : ""
                              }.svg`),
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-form",
                        {
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.getTaxpayer.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-8 ml-2",
                              attrs: {
                                align: "center",
                                justify: "end",
                                "no-gutters": "",
                              },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "mr-2",
                                  staticStyle: { width: "170px" },
                                },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "dni",
                                        rawName: "v-dni",
                                        value: "CL",
                                        expression: "'CL'",
                                      },
                                    ],
                                    attrs: {
                                      error: _vm.$v.filter.$error,
                                      placeholder: `Introduce el ${_vm.$t(
                                        "generals.RUT"
                                      )} o nombre`,
                                      outlined: "",
                                      required: "",
                                      "single-line": "",
                                      dense: "",
                                      maxlength: "60",
                                      "persistent-hint": "",
                                      "hide-details": "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        _vm.filter.length > 0
                                          ? {
                                              key: "append",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "mr-n2",
                                                      attrs: {
                                                        text: "",
                                                        "x-small": "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.resetSearch.apply(
                                                            null,
                                                            arguments
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          staticClass: "mt-1",
                                                          attrs: {
                                                            color: "grey-900",
                                                          },
                                                        },
                                                        [_vm._v("mdi-close")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            }
                                          : null,
                                      ],
                                      null,
                                      true
                                    ),
                                    model: {
                                      value: _vm.$v.filter.$model,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.$v.filter,
                                          "$model",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "$v.filter.$model",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "1" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { text: "", color: "grey-900" },
                                      on: { click: _vm.getTaxpayer },
                                    },
                                    [_vm._v("Buscar")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.$helpers.hasSomePermission(["add_customer"])
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "ml-2",
                              attrs: { color: "grey-900" },
                              on: {
                                click: function ($event) {
                                  _vm.dialogCustomer = true
                                },
                              },
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-domain"),
                              ]),
                              _vm._v("Agregar cliente"),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      !_vm.$helpers.hasSomePermission(["view_customer"])
        ? _c("PermissionDenied", { staticClass: "mt-14" })
        : [
            _c(
              "v-col",
              { staticClass: "mt-20 pa-0", attrs: { cols: "12" } },
              [
                _vm.loading
                  ? _c("skeleton-list")
                  : _c(
                      "v-col",
                      { staticClass: "px-0", attrs: { cols: "12" } },
                      [
                        _vm.list.length
                          ? [
                              _c("v-simple-table", {
                                key: _vm.reset,
                                class: [
                                  {
                                    "fixed-table":
                                      _vm.$store.state.base
                                        .isExpandNavigationDrawer,
                                  },
                                ],
                                attrs: {
                                  height: _vm.heightTable,
                                  "fixed-header": "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function () {
                                        return [
                                          _c("VTableHeaders", {
                                            attrs: { headers: _vm.headers },
                                            on: { sort: _vm.setSort },
                                          }),
                                          _c("v-divider", {
                                            staticStyle: {
                                              position: "absolute",
                                              "margin-top": "-6px",
                                              "min-width": "100%",
                                              "margin-left": "-5px",
                                              "z-index": "2",
                                            },
                                          }),
                                          _c(
                                            "tbody",
                                            { key: _vm.resetScroll },
                                            _vm._l(
                                              _vm.list,
                                              function (item, i) {
                                                return _c(
                                                  "tr",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "intersect",
                                                        rawName: "v-intersect",
                                                        value:
                                                          i + 1 ===
                                                          _vm.list?.length
                                                            ? _vm.loadMore
                                                            : "",
                                                        expression:
                                                          "(i + 1) === list?.length ? loadMore : ''",
                                                      },
                                                    ],
                                                    key: i,
                                                    staticStyle: {
                                                      cursor: "pointer",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handlerItem(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "td",
                                                      { staticClass: "body-2" },
                                                      [
                                                        item?.tax_id
                                                          ? _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.formatRut(
                                                                    item?.tax_id
                                                                  )
                                                                )
                                                              ),
                                                            ])
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "body-2 text--disabled font-italic",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Sin especificar"
                                                                ),
                                                              ]
                                                            ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "td",
                                                      { staticClass: "body-2" },
                                                      [
                                                        item.name
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "d-inline-block text-truncate",
                                                                staticStyle: {
                                                                  "max-width":
                                                                    "96%",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.name
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "body-2 text--disabled font-italic",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Sin especificar"
                                                                ),
                                                              ]
                                                            ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "body-2 text-end",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "dateTimeSecond"
                                                            )(item.created)
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  3893163378
                                ),
                              }),
                            ]
                          : (!_vm.list.length && !_vm.$route.query.ref) ||
                            (!_vm.list.length &&
                              _vm.$route.query.ref &&
                              _vm.filter.length) ||
                            !_vm.list.length
                          ? _c("v-empty-state", {
                              staticClass: "mt-10",
                              attrs: {
                                type: "customer",
                                id: "clientes",
                                height: 220,
                                hiddenDescription: false,
                                customClass: "mt-1",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "actions",
                                  fn: function () {
                                    return [
                                      !_vm.$route.query.ordering &&
                                      _vm.hiddenBtnEmpty
                                        ? [
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "ml-2",
                                                attrs: {
                                                  outlined: "",
                                                  ripple: false,
                                                  width: "153",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.$router
                                                      .replace({
                                                        name: _vm.$route.name,
                                                        params:
                                                          _vm.$route.params,
                                                        query: {
                                                          ref: "initial",
                                                        },
                                                      })
                                                      .catch(() => {})
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { staticClass: "mr-2" },
                                                  [
                                                    _vm._v(
                                                      "mdi-text-search-variant"
                                                    ),
                                                  ]
                                                ),
                                                _vm._v("Últimos registros"),
                                              ],
                                              1
                                            ),
                                          ]
                                        : _vm._e(),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            })
                          : _vm._e(),
                      ],
                      2
                    ),
              ],
              1
            ),
          ],
      _c(
        "v-dialog",
        {
          attrs: {
            width: "700",
            persistent: "",
            "no-click-animation": "",
            scrollable: "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogCustomer,
            callback: function ($$v) {
              _vm.dialogCustomer = $$v
            },
            expression: "dialogCustomer",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [
                          _vm._v(
                            _vm._s(!_vm.isEdit ? "Agregar" : "Editar") +
                              " cliente"
                          ),
                        ]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ml-3",
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogCustomer = false
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                {
                  staticClass: "py-4 px-0 overflow-y-auto",
                  staticStyle: { "max-height": "710px" },
                  attrs: { "min-height": "700", scrollable: "" },
                },
                [
                  _c(
                    "v-row",
                    { staticClass: "px-5", attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pa-0", attrs: { cols: "3" } },
                        [
                          _c("span", { staticClass: "grey-500--text body-1" }, [
                            _vm._v(_vm._s(_vm.$t("generals.RUT"))),
                          ]),
                          _c("v-text-field", {
                            directives: [
                              {
                                name: "dni",
                                rawName: "v-dni",
                                value: "CL",
                                expression: "'CL'",
                              },
                            ],
                            attrs: {
                              error: _vm.$v.customer.taxpayer.$error,
                              readonly: _vm.isEdit,
                              disabled: !_vm.$helpers.hasSomePermission([
                                "add_customer",
                              ]),
                              required: "",
                              outlined: "",
                              "single-line": "",
                              dense: "",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.$v.customer.taxpayer.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.customer.taxpayer,
                                  "$model",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "$v.customer.taxpayer.$model",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "pa-0 ml-3" },
                        [
                          _c("span", { staticClass: "grey-500--text body-1" }, [
                            _vm._v("Nombre de la organización"),
                          ]),
                          _c("v-text-field", {
                            attrs: {
                              error: _vm.$v.customer.name.$error,
                              disabled: !_vm.$helpers.hasSomePermission([
                                "add_customer",
                              ]),
                              outlined: "",
                              required: "",
                              "single-line": "",
                              dense: "",
                              maxlength: "100",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.$v.customer.name.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.customer.name,
                                  "$model",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "$v.customer.name.$model",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "px-5 my-4", attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pa-0", attrs: { cols: "12" } },
                        [
                          _c("span", { staticClass: "grey-500--text body-1" }, [
                            _vm._v("Actividad económica"),
                          ]),
                          _c("v-text-field", {
                            attrs: {
                              error: _vm.$v.customer.business_activity.$error,
                              disabled: !_vm.$helpers.hasSomePermission([
                                "add_customer",
                              ]),
                              outlined: "",
                              required: "",
                              "single-line": "",
                              dense: "",
                              maxlength: "40",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.$v.customer.business_activity.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.customer.business_activity,
                                  "$model",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression:
                                "$v.customer.business_activity.$model",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "pa-0 mt-4", attrs: { cols: "12" } },
                        [
                          _c("span", { staticClass: "grey-500--text body-1" }, [
                            _vm._v("Dirección"),
                          ]),
                          _c("v-text-field", {
                            attrs: {
                              error: _vm.$v.customer.address.$error,
                              disabled: !_vm.$helpers.hasSomePermission([
                                "add_customer",
                              ]),
                              outlined: "",
                              required: "",
                              "single-line": "",
                              dense: "",
                              maxlength: "40",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.$v.customer.address.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.customer.address,
                                  "$model",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "$v.customer.address.$model",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { staticClass: "my-4", attrs: { "no-gutters": "" } },
                        [
                          _c(
                            "v-col",
                            { staticClass: "pa-0" },
                            [
                              _c(
                                "span",
                                { staticClass: "grey-500--text body-1" },
                                [_vm._v("Comuna")]
                              ),
                              _c("v-autocomplete", {
                                attrs: {
                                  error: _vm.$v.customer.municipality.$error,
                                  disabled: !_vm.$helpers.hasSomePermission([
                                    "add_customer",
                                  ]),
                                  items:
                                    _vm.$store.getters["base/currentStates"] ||
                                    [],
                                  "item-text": "name",
                                  "item-value": "name",
                                  "single-line": "",
                                  "hide-details": "",
                                  dense: "",
                                  height: "40",
                                  outlined: "",
                                  required: "",
                                  placeholder: "Selecciona la comuna",
                                  "no-data-text": "No existen datos",
                                  "append-icon": "mdi-chevron-down",
                                },
                                model: {
                                  value: _vm.$v.customer.municipality.$model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.$v.customer.municipality,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.customer.municipality.$model",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "pa-0 ml-3" },
                            [
                              _c(
                                "span",
                                { staticClass: "grey-500--text body-1" },
                                [_vm._v("Ciudad")]
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  error: _vm.$v.customer.city.$error,
                                  disabled: !_vm.$helpers.hasSomePermission([
                                    "add_customer",
                                  ]),
                                  outlined: "",
                                  required: "",
                                  "single-line": "",
                                  dense: "",
                                  maxlength: "40",
                                  "hide-details": "",
                                },
                                model: {
                                  value: _vm.$v.customer.city.$model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.$v.customer.city,
                                      "$model",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "$v.customer.city.$model",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider", { staticClass: "my-4" }),
                  _c(
                    "div",
                    { staticClass: "px-5 pt-1" },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-0 mb-3 subtitle-2 grey-700--text font-weight-semibold",
                        },
                        [
                          _vm._v(" Agregar contactos "),
                          _c(
                            "v-chip",
                            {
                              staticClass: "ml-2 px-1 font-weight-regular",
                              attrs: {
                                "x-small": "",
                                color: "grey-background",
                              },
                            },
                            [_vm._v("Opcional")]
                          ),
                        ],
                        1
                      ),
                      _vm._l(_vm.contacts, function (d, i) {
                        return _c("div", { key: i }, [
                          _c(
                            "div",
                            {
                              staticClass: "py-1 d-flex justify-space-between",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "col-11 py-0 px-1" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "grey-500--text body-1" },
                                    [_vm._v("Email")]
                                  ),
                                  _c("v-text-field", {
                                    attrs: {
                                      error:
                                        _vm.$v.contacts.$each[i].email.$error,
                                      disabled: !_vm.$helpers.hasSomePermission(
                                        ["add_customer"]
                                      ),
                                      outlined: "",
                                      required: "",
                                      "single-line": "",
                                      dense: "",
                                      maxlength: "64",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value:
                                        _vm.$v.contacts.$each[i].email.$model,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.$v.contacts.$each[i].email,
                                          "$model",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "$v.contacts.$each[i].email.$model",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "col-1 pa-0",
                                  staticStyle: { "max-width": "30px" },
                                },
                                [
                                  _vm.contacts.length > 1
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass: "mt-5 ml-n2",
                                          attrs: {
                                            disabled:
                                              _vm.contacts.length === 1 ||
                                              !_vm.$helpers.hasSomePermission([
                                                "add_customer",
                                              ]),
                                            text: "",
                                            color: "grey-700",
                                            ripple: false,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.contacts.splice(i, 1)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "grey-700" } },
                                            [_vm._v("mdi-delete")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                        ])
                      }),
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "", color: "grey-900", ripple: false },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.addRowContacts.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { "x-small": "" } }, [
                            _vm._v("mdi-plus"),
                          ]),
                          _c(
                            "span",
                            { staticClass: "font-weight-medium body-1" },
                            [_vm._v("Agregar otro")]
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _vm.isEdit
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "px-5 mt-1 d-block grey-500--text body-1",
                        },
                        [
                          _vm._v(
                            " Creado el " +
                              _vm._s(
                                _vm._f("dateTimeSecond")(_vm.customer.created)
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.isEdit
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "px-5 mt-2 d-block grey-500--text body-1",
                        },
                        [
                          _vm._v(
                            " Actualizado el " +
                              _vm._s(
                                _vm._f("dateTimeSecond")(_vm.customer.updated)
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "px-5 py-2" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogCustomer = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        loading: _vm.$store.state.customers.createLoader,
                        disabled: !_vm.$helpers.hasSomePermission([
                          "add_customer",
                        ]),
                      },
                      on: {
                        click: function ($event) {
                          _vm.isEdit ? _vm.updateCustomer() : _vm.postCustomer()
                        },
                      },
                    },
                    [_vm._v("Guardar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }